export default __webpack_public_path__ + "static/media/united-kingdom-square.4fd04c4b.png";